import useCurrentOrganization from '@shared/hooks/organization/useCurrentOrganization';
import useOrganizationBilling from './useOrganizationBilling';
import { useOrganizationUsers } from '@account-settings/api/users';
import { useMemo } from 'react';
import { ORGANIZATION_USER_ROLES } from '@shared/constants';

const useActiveOrganizationPaymentDetails = (config = {}) => {
  const currentOrganization = useCurrentOrganization();
  const data = useOrganizationBilling(currentOrganization?.id, config);
  const {
    data: organizationUsers = [],
    isLoading: loadingUsers
  } = useOrganizationUsers(currentOrganization?.id);

  // @todo: update when the back-end adds this field to the billing endpoint
  const llmUserCount = useMemo(() => {
    return organizationUsers.filter(
      user => user.role === ORGANIZATION_USER_ROLES.LLM_ONLY
    ).length;
  }, [organizationUsers]);

  return {
    ...data,
    data: { ...data.data, llmUserCount },
    isLoading: loadingUsers || data.isLoading
  };
};

export default useActiveOrganizationPaymentDetails;
